import { alpha } from "@mui/material/styles";

import constants from "../../assets/constants";
import { OmniStringToDate } from "../../utils/helpers";

export const formatDateLabels = dates => {
  const labels = [];
  let lastYear = "";
  for (let i = 0; i < dates.length; i++) {
    let aDate = OmniStringToDate(dates[i]);
    labels.push(
      `${constants.monthNames[aDate.getMonth()]} ${aDate.getUTCDate()} ${
        lastYear !== aDate.getFullYear() ? (lastYear = aDate.getFullYear()) : ""
      }`,
    );
  }
  return labels;
};

export const extractAnalyticsDateLabels = analyticsRecords => {
  const labels = [];
  let lastYear = "";
  for (let i = 0; i < analyticsRecords.length; i++) {
    let aDate = OmniStringToDate(analyticsRecords[i].startDateTimeUtc);
    labels.push(
      `${constants.monthNames[aDate.getMonth()]} ${aDate.getUTCDate()} ${
        lastYear !== aDate.getFullYear() ? (lastYear = aDate.getFullYear()) : ""
      }`,
    );
  }
  return labels;
};

export const getGraphColor = (theme, index, opacityValue = 0) => {
  //zero is a no-op
  let colorIndex = index;
  if (colorIndex >= theme.graphColors.length) {
    colorIndex = 0;
  }
  if (opacityValue > 0) {
    return alpha(theme.graphColors[colorIndex], opacityValue);
  } else {
    return theme.graphColors[colorIndex];
  }
};

export const extractGraphDataFromArray = objArray => {
  let labels = objArray.map(a => a.date).slice(0);
  let values = objArray.map(a => a.value).slice(0);

  return { labels, values };
};
